import { searchWord } from "../../helpers/common";

export const findSg = (item, filters, type) => {
    let isMatched = false;
    if (type === 'field') {
        isMatched = searchWord(item.geo_shape_name, filters.searchText);
    } else if (type === 'user') {
        isMatched = searchWord(item.name, filters.searchText);
    } else {
        isMatched = searchWord(item.scout_member_name, filters.searchText);
    }
    return isMatched;
}

export const compareTwo = (array1, array2) => {
    const added = [], removed = [];
    for (const id of array2) {
        if (array1.indexOf(id) < 0) added.push(id);
    }

    for (const id of array1) {
        if (array2.indexOf(id) < 0) removed.push(id);
    }

    return { added, removed };
}
